import { MatchingRule } from '../../services/matching-rule/matching-rule.service';

export interface IColumnDefinition {
  field: string;
  headerName?: string;
  filter?: string;
  groupName?: string;
  [key: string]: any;
}

export const TAB_LABELS: Record<MatchingRule, string> = {
  cardealer: 'cardealer',
  leasing: 'leasing',
  fleet: 'fleet',
};

export const TAB_ATTRIBUTE_PREFIX: Record<MatchingRule, string> = {
  cardealer: 'ma',
  leasing: 'lc',
  fleet: 'fm',
};

export const DEFAULT_VEHICLE_GRID = [
  {
    x: 0, y: 0, w: 3, selector: 'tt-vehicle-info-item',
    input: { cardConfig: { prop: 'lessor_name' } }
  },
  {
    x: 3, y: 0, w: 3, selector: 'tt-vehicle-info-item',
    input: { cardConfig: { prop: 'manufacturer_vehicle_driver_name' } }
  },
  {
    x: 0, y: 1, w: 3, selector: 'tt-vehicle-info-item-combo',
    input: { cardConfig: { prop: 'cardealer_order_date', prop2: 'production_order_date' } }
  },
  {
    x: 3, y: 1, w: 3, selector: 'tt-vehicle-info-item-combo',
    input: { cardConfig: { prop: 'current_delivery_date_planned', prop2: 'yoma_delivery_date_end_customer_estimate' } }
  }
];
